import {combineEpics} from 'redux-observable';
import cubesEpic from './cubesEpic';

export default combineEpics(cubesEpic);
